/**
 * ModuleList — read-only view of which seat types have access to each module.
 *
 * Props:
 *   modules   — [{ id, slug, name }]
 *   seatTypes — [{ id, slug, name, modules: [{ id, slug, name }] }]
 *   dark      — boolean
 */

export default function ModuleList({ modules, seatTypes, dark }) {
  const textPrim  = dark ? 'rgba(207,226,232,0.92)' : '#07272D'
  const textMuted = dark ? 'rgba(91,132,148,0.80)'  : 'rgba(7,39,45,0.50)'
  const rowBorder = dark ? 'rgba(255,255,255,0.06)' : 'rgba(7,39,45,0.07)'
  const pillBg    = dark ? 'rgba(29,158,117,0.15)'  : 'rgba(29,158,117,0.10)'
  const pillText  = dark ? '#1D9E75'                 : '#137a58'
  const noBg      = dark ? 'rgba(255,255,255,0.05)' : 'rgba(7,39,45,0.05)'
  const noText    = textMuted

  if (!modules.length) {
    return (
      <div style={{ padding: '20px 20px', fontFamily: '"DM Sans", sans-serif', fontSize: 13, color: textMuted }}>
        No modules defined.
      </div>
    )
  }

  return (
    <div>
      {/* Column headers */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: `140px repeat(${seatTypes.length}, 1fr)`,
        padding: '8px 20px',
        borderBottom: `0.5px solid ${rowBorder}`,
        gap: 12,
      }}>
        <div style={{ fontFamily: '"DM Mono", monospace', fontSize: 10, color: textMuted, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
          Module
        </div>
        {seatTypes.map(st => (
          <div key={st.id} style={{ fontFamily: '"DM Mono", monospace', fontSize: 10, color: textMuted, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            {st.name}
          </div>
        ))}
      </div>

      {modules.map(m => (
        <div
          key={m.id}
          style={{
            display: 'grid',
            gridTemplateColumns: `140px repeat(${seatTypes.length}, 1fr)`,
            alignItems: 'center',
            padding: '10px 20px',
            borderBottom: `0.5px solid ${rowBorder}`,
            gap: 12,
          }}
        >
          <div style={{ fontFamily: '"DM Sans", sans-serif', fontSize: 13, color: textPrim, fontWeight: 500 }}>
            {m.name}
          </div>
          {seatTypes.map(st => {
            const hasAccess = Array.isArray(st.modules) && st.modules.some(sm => sm.id === m.id || sm.slug === m.slug)
            return (
              <div key={st.id}>
                {hasAccess ? (
                  <span style={{
                    display: 'inline-block', padding: '2px 8px', borderRadius: 20,
                    background: pillBg, color: pillText,
                    fontFamily: '"DM Sans", sans-serif', fontSize: 11, fontWeight: 500,
                  }}>
                    ✓ Access
                  </span>
                ) : (
                  <span style={{
                    display: 'inline-block', padding: '2px 8px', borderRadius: 20,
                    background: noBg, color: noText,
                    fontFamily: '"DM Sans", sans-serif', fontSize: 11,
                  }}>
                    —
                  </span>
                )}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}
